import { render, staticRenderFns } from "./PhoneTable.vue?vue&type=template&id=0141e031"
import script from "./PhoneTable.vue?vue&type=script&lang=ts"
export * from "./PhoneTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports